import { all, call, put, takeLatest } from 'redux-saga/effects';
import { processRequest } from '../../services/Api';
import { learningPathActionTypes } from './Constants';
import * as learningPathsActions from './Actions';
import * as errorHandlerActions from '../errorHandler/Actions';

export default function* () {
	yield all([
		yield takeLatest(
			learningPathActionTypes.GET_LEARNING_PATH_OPTIONS,
			handleGetLearningPathOptionsRequest,
		),
		yield takeLatest(
			learningPathActionTypes.CREATE_LEARNING_PATH,
			handleCreateLearningPathRequest,
		),
		yield takeLatest(
			learningPathActionTypes.MANAGE_LEARNING_PATH_STEP,
			handleManageLearningPathStepRequest,
		),
		yield takeLatest(
			learningPathActionTypes.CLOSE_LEARNING_PATH,
			handleCloseLearningPathRequest,
		),
	]);
}

export function* handleGetLearningPathOptionsRequest({ payload }) {
	try {
		const { data: requestData } = payload || {};

		const { data } = yield call(processRequest, 'learning_paths/new', 'GET', requestData);

		yield put(learningPathsActions.getLearningPathOptionsSuccess(data));
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'notification'));
		yield put(learningPathsActions.getLearningPathOptionsError());
	}
}

export function* handleCreateLearningPathRequest({ payload }) {
	try {
		const { data: requestData, callback } = payload || {};

		const { data } = yield call(processRequest, 'learning_paths', 'POST', requestData);

		if (callback) callback(data);

		yield put(learningPathsActions.createLearningPathSuccess());
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'notification'));
		yield put(learningPathsActions.createLearningPathError());
	}
}

export function* handleManageLearningPathStepRequest({ payload }) {
	try {
		const { id, data: requestData, callback } = payload || {};

		yield call(processRequest, `learning_path_topic_steps/${id}`, 'PUT', requestData);

		yield put(learningPathsActions.manageLearningPathStepFinal());

		if (callback) callback();
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'notification'));
		yield put(learningPathsActions.manageLearningPathStepFinal());
	}
}

export function* handleCloseLearningPathRequest({ payload }) {
	try {
		const { id, callback } = payload || {};

		yield call(processRequest, `learning_paths/${id}`, 'PUT', { closed: true });

		if (callback) callback();

		yield put(learningPathsActions.closeLearningPathFinal());
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'notification'));
		yield put(learningPathsActions.closeLearningPathFinal());
	}
}
